export default __webpack_public_path__ + "static/media/App-Store_Sprite-Atlas.ccc62184.svg";